import { axiosWithAuth } from "@/lib/AxiosClient";

export class Observation {
  constructor(id: string, name: string, description: string | null, typeCodeId: string, tenantId: string, siteId: string, areaId: string | null, featureId: string | null, latitude: number | null, longitude: number | null) {
    this.id = id
    this.name = name
    this.description = description
    this.typeCodeId = typeCodeId
    this.tenantId = tenantId
    this.siteId = siteId
    this.areaId = areaId
    this.featureId = featureId
    this.latitude = latitude
    this.longitude = longitude
  }

  id: string
  name: string
  description: string | null
  tenantId: string
  siteId: string
  areaId: string | null
  featureId: string | null
  typeCodeId: string
  speciesId: string | null = null
  observedAt: string | null = null
  observedById: string | null = null
  latitude: number | null = null
  longitude: number | null = null
  areaName: string | null = null
  featureTypeId: string | null = null
  featureName: string | null = null
  featureTypeName: string | null = null
  featureTypeSubType: string | null = null
  observedByName: string | null = null
  attachmentUrl: string | null = null
}

export class ObservationService {
  private static readonly BASE_PATH = "/api/observations"
  private static instance = axiosWithAuth;

  static async getById(observationId: string): Promise<Observation> {
    const response = await this.instance.get<Observation>(`${this.BASE_PATH}/${observationId}`);
    return response.data;
  }

  static async create(observation: Omit<Observation, "id">): Promise<Observation> {
    const response = await this.instance.post<Observation>(this.BASE_PATH, observation);
    return response.data;
  }  

  static async update(observationId: string, observation: Observation): Promise<void> {
    await this.instance.put<void>(`${this.BASE_PATH}/${observationId}`, observation);
  }

  static async getByFeatureId(featureId: string): Promise<Observation[]> {
    const response = await this.instance.get<Observation[]>(`${this.BASE_PATH}/features/${featureId}`);
    return response.data;
  }

  static async getByFeatureTypeId(featureTypeId: string): Promise<Observation[]> {
    const response = await this.instance.get<Observation[]>(`${this.BASE_PATH}/featuretypes/${featureTypeId}`);
    return response.data;
  }

  static async getBySiteId(siteId: string): Promise<Observation[]> {
    const response = await this.instance.get<Observation[]>(`${this.BASE_PATH}/sites/${siteId}`);
    return response.data;
  }

  static async delete(observationId: string): Promise<void> {
    await this.instance.delete<void>(`${this.BASE_PATH}/${observationId}`)
  }

  static async getByAreaIdCourse(areaId: string): Promise<Observation[]> {
    const response = await this.instance.get<Observation[]>(`${this.BASE_PATH}/areas/${areaId}/course`);
    return response.data;
  }

  static async getByAreaIdHabitat(areaId: string): Promise<Observation[]> {
    const response = await this.instance.get<Observation[]>(`${this.BASE_PATH}/areas/${areaId}/habitat`);
    return response.data;
  }

  static async getByAreaId(areaId: string): Promise<Observation[]> {
    const response = await this.instance.get<Observation[]>(`${this.BASE_PATH}/areas/${areaId}`);
    return response.data;
  }
}